//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import { useEffect, useMemo, useState } from "react";
import apiclients from "../../api/apiclients";

export const useArangoPlatformFeature = (organizationId?: string) => {
  const { idashboardClient } = apiclients;
  const [featureFlags, setFeatureFlags] = useState<string[]>([]);

  useEffect(() => {
    const loadFeatureFlags = async () => {
      if (!organizationId) {
        setFeatureFlags([]);
        return;
      }
      try {
        const res = await idashboardClient.GetFeatureFlags({
          subject: {
            organization_id: organizationId,
          },
        });
        setFeatureFlags(res.flags || []);
      } catch {
        setFeatureFlags([]);
      }
    };
    void loadFeatureFlags();
  }, [idashboardClient, organizationId]);

  const isArangoPlatformFeature = useMemo(() => {
    return featureFlags.includes("ArangoPlatform") || featureFlags.includes("ArangoDBPlatform");
  }, [featureFlags]);

  return { isArangoPlatformFeature };
};
